import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './GrowthPartners.css';
import teamPhoto from '../assets/Team Photo.png';

const GrowthPartners = () => {
  const { t } = useTranslation();
  const sectionRef = useRef(null);

  // Reveal animation
  useEffect(() => {
    const section = sectionRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          section.classList.add('visible');
          observer.unobserve(section);
        }
      },
      { threshold: 0.2 }
    );
    if (section) observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="gp-diagonal growth-partners" id="growth-partners" ref={sectionRef}>
      <div className="gp-bg-shape gp-shape-1"></div>
      <div className="gp-bg-shape gp-shape-2"></div>
      <picture>
        <source srcSet={teamPhoto.replace(/\.(jpg|jpeg|png)$/, '.webp')} type="image/webp" />
        <img src={teamPhoto} alt={t('teamPhotoAlt')} loading="lazy" className="gp-photo" />
      </picture>
      <div className="gp-headline-badge">{t('meetGrowthPartnersTitle')}</div>
      <p className="gp-subtitle">{t('meetGrowthPartnersSubtitle')}</p>
      <div className="gp-about-link-bottom">
        <Link to="/about" className="gp-link" aria-label={t('aboutLinkAria')}>
          {t('aboutLinkText')} 
        </Link>
      </div>
      <ul className="gp-chips">
        <li className="gp-chip">
          <span className="gp-chip-name">{t('heikoName')}</span>
          <small className="gp-chip-role">{t('heikoTitle')}</small>
        </li>
        <li className="gp-chip">
          <span className="gp-chip-name">{t('alexName')}</span>
          <small className="gp-chip-role">{t('alexTitle')}</small>
        </li>
        <li className="gp-chip">
          <span className="gp-chip-name">{t('franziName')}</span>
          <small className="gp-chip-role">{t('franziTitle')}</small>
        </li>
      </ul>
    </section>
  );
};

export default GrowthPartners;
